import React from "react";
import { DoneButton } from "@deliverr/ui-facility";
import { useFreightArrival } from "../useFreightArrival";

export const FreightArrivalSendToFulfillmentDoneButton: React.FC = () => {
  const { restartFreightArrival } = useFreightArrival();

  return <DoneButton onClick={restartFreightArrival} block />;
};
